<div #appBackground id="app-background" class="background" style="opacity: 0"></div>
<ngx-spinner bdColor="rgba(0,0,0,.5)"
             size="medium"
             color="#fff"
             type="ball-fall">
  <p class="h5" style="color: white; display: inline;">{{ 'loading.' + (o.activatedRouteData.state || 'standard') | translate }}<animated-ellipsis></animated-ellipsis></p>
</ngx-spinner>
<div class="app-container">
  <app-nav-menu></app-nav-menu>
  <div class="body-content" [@routerTransition]="{ value: getState(o) }">
    <router-outlet #o="outlet"></router-outlet>
  </div>
  <div id="to-top" [attr.title]="'label.till-topp' | translate" [class.show-to-top]="windowScrolled" (click)="scrollToTop()">
    <fa-icon [icon]="['fas', 'arrow-circle-up']" [styles]="{'color': '#fff', 'width': '100%', 'height': '100%', 'filter': 'drop-shadow(0 3px 6px rgba(0, 0, 0, .4))'}"></fa-icon>
  </div>
</div>
